// eslint-disable-next-line no-unused-vars
export class MapboxCustomControl {
  map: any
  container: any
  html: string

  constructor (options: any) {
    this.html = options.html
  }

  onAdd (map: any) {
    this.map = map
    this.container = document.createElement('div')
    this.container.innerHTML = `${this.html}`
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group floating-card custom-mapboxgl-actions'
    return this.container
  }

  onRemove () {
    this.container?.parentNode?.removeChild(this.container)
    this.map = undefined
  }
}
